import React, { ReactElement, ReactNode } from 'react';

import { DialogProps } from '@material-ui/core';
import {
  CustomDialog,
  CustomDialogActions,
  CustomDialogContent,
} from './FsDefaultDialog.style-elements';
import FsDialogTitle from '../FsDialogTitle';

export interface FsHelperDialogProps {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  children?: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  fullWidth?: boolean;
  actionButtons?: ReactElement[];
}

const FsDefaultDialog: React.FC<
  FsHelperDialogProps &
    Pick<DialogProps, 'disableBackdropClick' | 'disableEscapeKeyDown'>
> = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'md',
  fullWidth = false,
  actionButtons,
  ...otherDialogProps
}) => {
  const handleClose = (): void => {
    if (onClose) onClose();
  };

  return (
    <CustomDialog
      {...otherDialogProps}
      aria-labelledby="simple-dialog-title"
      data-test="tooltip-dialog"
      open={isOpen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      disableAutoFocus
      onClose={handleClose}
    >
      <FsDialogTitle id="helper-dialog" onClose={handleClose}>
        {title}
      </FsDialogTitle>

      <CustomDialogContent dividers>{children}</CustomDialogContent>
      {actionButtons && (
        <CustomDialogActions>{actionButtons}</CustomDialogActions>
      )}
    </CustomDialog>
  );
};

export default FsDefaultDialog;
